var scope_0 = require('/var/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/53ae217d48ade9f74e4804a2e9a4c71c.js').default;
var scope_1 = require('/var/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/868b6b7d5ab96047239f26e8f35dcfc6.js').default;
var scope_2 = require('/var/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    